<template>
    <div class="main-box" style="height: 700px;">
        <xr-table ref="xrTable" :configure="configure"></xr-table>
    </div>
</template>

<script>

  export default {
    // userAdd
    name: 'interfaceCategorySelect',
    data() {
      return {
        isProjectViewShow: false,
        configure: {
          url: '/web/service?method=tCoreInterfaceCategory_list',
          isShowSearch: true,
          pagination: true, //允许分页（默认true）
          // editUrl: '/web/service?method=tCalProject_edit',
          idField: 'id',
          tableHeight: 600,
          defaultNoLoadData: false,
          isSelectFirst: true,
          that: this,
          columns: [
            {
              field: 'radio',
              width: 60,
            },
            {
              field: 'categoryName',
              title: '数据源名称',
              width: 300,
              condition: {
                searchType: 'input',
                searchName: 'categoryNameSearch',
                value:''
              },
            },
            {
              field: 'categoryCode',
              title: '数据源编码',
              width: 380,
              condition: {
                searchType: 'input',
                searchName: 'categoryCodeSearch',
                value:''
              },
            },
            {
              field: 'createTime',
              title: '创建时间',
              condition: {
                searchType: 'input',
                searchName: 'createTimeSearch',
                value:''
              },
            }
          ],
          toolbar: [
            {
              text: '确定',
              iconCls: 'wk wk-confirm',
              that: this,
              handler: function () {
                this.that.handleAddOpenDialog();
              }
            },{
              text: '取消',
              iconCls: 'wk wk-cancel2',
              that: this,
              handler: function () {
                this.that.$emit('cancelMethod');
              }
            },
          ],
          onClickRow: function(row){
          }
        }
      }
    },
    components: {

    },
    methods: {
      init(){
        this.$nextTick(()=>{
          this.$refs.xrTable.getData();
        })
      },
      handleAddOpenDialog(){
        let row = this.$refs.xrTable.radio_row;
        if(!row){
          this.$message.warning('请选择一条数据！')
          return false;
        }
        this.$emit('confirmMethod',row);
      },

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PageSelect/generate/interfaceCategorySelect.vue